import { ModelHelper } from '../classes/model-helper';

export class RestorationElement {
	uid: string;
	type: string;
	toothNumber: number;
	preparationMarginDrawn: boolean;
	metaInfo: string;
	designMode: string;
	baseLineDrawn: boolean;

	/**
	 *
	 *
	 * Static mapping function
	 *
	 *
	 *
	 * @param data
	 * @param item
	 * @returns RestorationElement
	 */
	static map(data: any, item: RestorationElement = new RestorationElement()): RestorationElement {
		return item.map(data);
	}

	/**
	 *
	 *
	 * Non static mapping function
	 *
	 *
	 *
	 * @param data
	 * @return RestorationElement
	 */
	public map(data: any): RestorationElement {
		ModelHelper.map(data, this, 'uid');
		ModelHelper.map(data, this, 'type');
		ModelHelper.map(data, this, 'toothNumber');
		ModelHelper.map(data, this, 'preparationMarginDrawn');
		ModelHelper.map(data, this, 'metaInfo');
		ModelHelper.map(data, this, 'designMode');
		ModelHelper.map(data, this, 'baseLineDrawn');

		return this;
	}
}
